import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { DateRangeCustom } from '../../common/html/input/DateRangeCustom'
import { changeFilter, selectFilter } from '../store/slice'

export const ExpireDate = () => {
  const dispatch = useDispatch()

  const fromDate = useSelector(selectFilter('ExpiryDateFrom'))
  const toDate = useSelector(selectFilter('ExpiryDateTo'))

  const onFromChange = (value) => {
    dispatch(changeFilter({ ExpiryDateFrom: value, Page: 1 }))
  }

  const onToChange = (value) => {
    dispatch(changeFilter({ ExpiryDateTo: value, Page: 1 }))
  }

  return (
    <>
      <div>
        <Element
          elementName="p"
          style={{
            color: '#191D25',
            fontWeight: 600,
          }}
        >
          <Translate value="library.downloadedFiles.EXPIRY_DATE" />
        </Element>
        <div className="dFlex gap1">
          <DateRangeCustom
            onFromChange={onFromChange}
            onToChange={onToChange}
            fromDate={fromDate}
            toDate={toDate}
          />
        </div>
      </div>
    </>
  )
}
